"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhraní pro konfiguraci rolí subjektu. Generated from cz.marbes.api.subjekt.v1.conf.SubjektRoleService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:38:13Z                      #

// ##############################################################

var SubjektRoleApi = function () {
  function SubjektRoleApi() {
    (0, _classCallCheck3.default)(this, SubjektRoleApi);
  }

  (0, _createClass3.default)(SubjektRoleApi, null, [{
    key: "updateSubjektRoleConf",

    /**
     * Aktualizace role subjektu.
     *
     * @param kod 
     * @param subjektRoleConf konfigurace role
     * @return aktualizovaná konfigurace role
     */
    value: function updateSubjektRoleConf(kod, subjektRoleConf) {
      var uri = serverContextPath + ("/api/subjekt/v1/subjektRole/" + kod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, UpdateMethods.updateSubjektRoleConf_60B74Bv1(subjektRoleConf), headers));
    }

    /**
     * Vytvoření nové role subjektu.
     *
     * @param subjektRoleConf konfigurace role
     * @return vytvořená konfigurace role
     */

  }, {
    key: "createSubjektRoleConf",
    value: function createSubjektRoleConf(subjektRoleConf) {
      var uri = serverContextPath + "/api/subjekt/v1/subjektRole";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, UpdateMethods.updateSubjektRoleConf_60B74Bv1(subjektRoleConf), headers));
    }

    /**
     * Načtení role subjektu dle kódu.
     *
     * @param kodRole kód role
     * @return načtená role subjektu
     */

  }, {
    key: "getSubjektRoleByKod",
    value: function getSubjektRoleByKod(kodRole) {
      var uri = serverContextPath + "/api/subjekt/v1/subjektRole";
      var headers = undefined;
      var params = { kodRole: kodRole };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return SubjektRoleApi;
}();

exports.default = SubjektRoleApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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